import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_CERKL_ENDPOINT_BASE_URL + "/broadcast/teams"
});

export default instance;
